import { connect } from 'react-redux'
import SeminarTabs from './Seminars'

const mapStateToProps = (state, ownProps) => {
  return {
    isFetchingRooms: state.rooms.isFetchingRooms,
    view: state.loginLayout.view,
    user: state.loginLayout.user,
    ...ownProps
  }
}

const SeminarContainer = connect(mapStateToProps)(
  SeminarTabs
)

export default SeminarContainer



// WEBPACK FOOTER //
// src/components/Seminars/SeminarsContainer.js